import request from "@/utils/request";

export function getList() {
  return request({ url: "/user/address/list", method: "get" });
}

export function getDefault() {
  return request({ url: "/user/address/default", method: "get" });
}

export function save(data) {
  return request({ url: "/user/address/save", method: "post", data: data });
}

export function del(id) {
  return request({ url: "/user/address/" + id + "/delete", method: "post" });
}
